const sDashboardElemente = (lead, LEAD) => ({
    vehicleUbersicht: { n: 'Übersicht', group: 'Fahrzeuge', hidden: !LEAD },
    vehicleStandzeit: { n: 'Standzeiten', group: 'Fahrzeuge', hidden: !LEAD },
    vehicleStandzeitEins: { n: 'Standzeit Eins', group: 'Fahrzeuge', hidden: !LEAD },
    leadUbersicht: { n: 'Übersicht', group: 'Leads', hidden: !lead },
    leadReaktion: { n: 'Reaktionszeiten', group: 'Leads', hidden: !LEAD || !lead },
    leadPortale: { n: 'Portale', group: 'Leads', hidden: !LEAD || !lead },
    leadStatusNeu: { n: 'Status neuer Leads', group: 'Leads', hidden: !LEAD || !lead },
    leadStatusBeendet: { n: 'Status beendeter Leads', group: 'Leads', hidden: !LEAD || !lead },
    leadMitarbeiter: { n: 'Mitarbeiter', group: 'Leads', hidden: !LEAD || !lead },
});

export default sDashboardElemente;
